export const isAndroid = /android/i.test(window.navigator.userAgent)